<sh-ag-grid-responsive-wrapper
	id="sh-ag-grid-responsive-wrapper"
	[gridApi]="gridApi"
	[minNoRowsHeight]="minNoRowsHeight"
	[minLoadingHeight]="minLoadingHeight"
	[minHeight]="minHeight"
	[ngClass]="themeClass"
>
	<ag-grid-angular
		id="sh-ag-grid-table"
		[rowData]="rowData"
		[columnDefs]="columnDefs"
		[gridOptions]="gridOptions"
		(gridReady)="onGridReady($event)"
	>
	</ag-grid-angular>
</sh-ag-grid-responsive-wrapper>
